<template>
  <div
    id="app"
    v-loading="loading"
    element-loading-background="transparent"
    element-loading-custom-class="custom-loading"
  >
    <div class="main-container">
      <!-- 两行布局 -->
      <div class="title-container"></div>
      
      <div class="rank-container">
        <div class="sub-rank-container-left">
          <!-- 左右分栏 -->
           <div class="sub-rank-number">{{ maleGroupGmv }}</div>
        </div>
        <div class="sub-rank-container-right">
          <div class="sub-rank-number">{{ femaleGroupGmv  }}</div>
        </div>
        <!-- <div
          :class="`rank-item rank-${idx + 1}-item`"
          v-for="(item, idx) in rankData"
          :key="`rankItem${idx}`"
        > -->
          <!-- 三栏布局 -->
          <!-- <div class="shipper-avatar">
            <img :src="item['avatar']" />
          </div>
          <div class="shipper-tip"></div>
          <div class="shipper-amount">
            <span>{{ item["amount"] }}</span>
          </div>
        </div> -->
      </div>
    </div>
    <div class="button-block">
      <!-- 刷新按钮区 -->
      <el-button :icon="RefreshIcon" circle @click="handleRefreshData" />
    </div>
  </div>
</template>

<script>
import { Refresh } from "@element-plus/icons-vue";
import shipperDataApi from "@/apis/shipperData";
import moment from "moment";
export default {
  name: "App",
  components: {},
  data() {
    return {
      loading: false, // 加载状态
      maleGmv: 0,
      femaleGmv: 0,
      RefreshIcon: Refresh,
    };
  },
  computed: {
    maleGroupGmv(){
      return this.formatCurrencySimple(this.maleGmv, 0)
    },
    femaleGroupGmv(){
      return this.formatCurrencySimple(this.femaleGmv, 0)
    }
  },
  mounted() {
    //
    this.fetchShipperData();
    this.getRouteParams();
  },
  methods: {
    // 格式化金额
    formatCurrencySimple(num, decimals = 2) {
      const number = parseFloat(num);
      if (isNaN(number)) return "0.00";

      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    },
    // 获取货主数据
    async fetchShipperData() {
      this.loading = true;
      const params = this.getRouteParams();
      const {rank} = await shipperDataApi.getYjShipperGroupData(params);
      this.maleGmv = rank['male_group_gmv'] || 0
      this.femaleGmv = rank['female_group_gmv'] || 0
      // 打印明细
      console.log('male list:', rank['male_group_list']|| [])
      console.log('female list:', rank['female_group_list']|| [])
      this.loading = false;
    },
    // 获取路由参数
    getRouteParams() {
      // 获取查询参数
      const { start_date, end_date } = this.$route.query;
      if (!start_date || !end_date) return {};

      const daysDiff = moment(end_date).diff(moment(start_date), "days");
        if (daysDiff > 30) {
          this.$message.warning("日期范围不能超过30天");
          return {};
      }

      return { start_date, end_date };
    },
    // 刷新数据
    async handleRefreshData() {
      await this.fetchShipperData();
      this.getRouteParams();
    },
  },
};
</script>

<style>
/* 设置最小视窗尺寸 */
:root {
  --min-width: 1200px;
  --min-height: 675px;
}

/* 主容器 */
.main-container {
  width: 100vw;
  height: calc(100vw * 1080 / 1920);
  /* background-color: #000000; */
  /* 背景设置 */
  background: url("./assets/yzCeleb11Imgs/bg.jpg") no-repeat center center;
  background-size: cover; /* 确保整个图片可见 */
  /* border: red 1px solid; */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  font-feature-settings: "tnum";
  font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, Noto Sans CJK SC, Microsoft YaHei, 微软雅黑, sans-serif;
}
/* 标题栏容器 */
.title-container {
  /* border: green 1px solid; */
  width: 60%;
  height: 30%;
  /* 背景设置 */
  background: url("./assets/yzCeleb11Imgs/title.png") no-repeat center
    center;
  background-size: contain; /* 确保整个图片可见 */
  position: relative;
  margin-top: 1%;
}
/* 排名容器 */
.rank-container {
  /* border: green 1px solid; */
  width: 95%;
  height: 70%;
  display: flex;
  margin-top: 0.5%;
  margin-bottom: 0.5%;
  gap: 2%;
  /* border: #000000 1px solid; */
}
.sub-rank-container-left{
  flex:0.5;
  /* border: #9c0000 1px solid; */
  background: url("./assets/yzCeleb11Imgs/left_bg.png") no-repeat center
    center;
  background-size: contain; /* 确保整个图片可见 */
  position: relative;
}
.sub-rank-container-right{
  flex:0.5;
  /* border: #9c0000 1px solid; */
  background: url("./assets/yzCeleb11Imgs/right_bg.png") no-repeat center
    center;
  background-size: contain; /* 确保整个图片可见 */
  position: relative;
}
.sub-rank-number{
  color: #d52702;
  position: absolute;
  bottom:10%;
  width: 100%;
  height: 18%;
  font-weight: bold;
  letter-spacing: 0.07em;
  /* line-height: 20%; */
  font-size: clamp(18px, 4.6vw, 90px);
  text-align: center;
  /* border: #000000 1px solid; */
}
.button-block {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100px;
  height: 40px;
  /* border: red 1px solid; */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #000000;

  /* 确保容器占满视窗 */
  width: 100vw;
  height: 100vh;
  min-width: var(--min-width);
  min-height: var(--min-height);

  /* 使用flex布局确保内容居中 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  user-select: none;
}

/* 确保html和body元素也占满全屏并设置最小尺寸 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.custom-loading .el-loading-spinner .circular {
  color: white !important;
}

.custom-loading .el-loading-spinner .path {
  stroke: white !important;
}

/* 响应式处理 - 当视窗比例与1920*1080不匹配时，两侧或上下显示黑色 */
/* @media (max-aspect-ratio: 16/9) {
  #app {
    background-size: auto 100%;
  }
}

@media (min-aspect-ratio: 16/9) {
  #app {
    background-size: 100% auto;
  }
} */
</style>
